// extracted by mini-css-extract-plugin
export var dividerContainer = "_6o-0";
export var line = "_6o-1";